import { render, staticRenderFns } from "./newInspection.vue?vue&type=template&id=00189605&scoped=true"
import script from "./newInspection.vue?vue&type=script&lang=js"
export * from "./newInspection.vue?vue&type=script&lang=js"
import style0 from "./newInspection.vue?vue&type=style&index=0&id=00189605&prod&lang=css"
import style1 from "./newInspection.vue?vue&type=style&index=1&id=00189605&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00189605",
  null
  
)

export default component.exports